var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"success",attrs:{"src":require("@/assets/images/success.png"),"alt":"成功"}}),_c('p',[_vm._v(_vm._s(_vm.title)+"...")]),_c('p',[_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")])]),_c('server-bank',{attrs:{"productId":this.$route.query.productId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }